


























































































import { Vue, Component } from "vue-property-decorator";

import ContentComponent from "@/components/layout/ContentComponent.vue";
import LoginFormBoxComponent from "@/components/common/form/LoginFormBoxComponent.vue";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import SidebarContentHeaderComponent from "@/components/layout/SidebarContentHeaderComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import InputComponent from "@/components/common/form/InputComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import ErrorBarComponent from "@/components/common/parts/ErrorBarComponent.vue";
import SuccessBarComponent from "@/components/common/parts/SuccessBarComponent.vue";
import { getRoutePath } from "@/router/routes";
import { checkValidation } from "@/typescript/lib/common/check_validation";
import { postUserPassApi } from "@/typescript/api_client/emesh_api/passwords/user_pass_api";
import ConfirmDialogComponent from "@/components/common/parts/ConfirmDialogComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";

@Component({
  components: {
    ContentComponent,
    LoginFormBoxComponent,
    HeaderComponent,
    SidebarContentHeaderComponent,
    MenubarComponent,
    InputComponent,
    ButtonComponent,
    MainComponent,
    ErrorBarComponent,
    SuccessBarComponent,
    ConfirmDialogComponent,
    FooterComponent
  }
})
export default class PasswordsEditPage extends Vue {
  currentPassword: string = "";
  newPassword: string = "";
  newPassVerification: string = "";

  newPasswordValidationMsg: string = "";
  isSuccess: boolean = false;
  currentPasswordValidationMsg: string = "";
  isConfirmDialogOpen: boolean = false;

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }

  hideError() {
    this.newPasswordValidationMsg = "";
    this.currentPasswordValidationMsg = "";
    this.isSuccess = false;
  }

  onClickChangeButton() {
    const passwordReg = RegExp(/^\w{12,}$/);

    const validation = checkValidation([
      {
        condition: !passwordReg.test(this.newPassword),
        errorMsg: "12 文字以上の半角英数字を使用してください"
      },
      {
        condition: this.newPassword !== this.newPassVerification,
        errorMsg: "新しいパスワードと一致しません"
      }
    ]);

    if (validation.length) {
      this.newPasswordValidationMsg = validation[0].errorMsg;
      this.currentPasswordValidationMsg = "";
      return;
    }

    postUserPassApi({
      loginId: this.$store.state.userInfo.login_id,
      oldPass: this.currentPassword,
      newPass: this.newPassword,
      newPassVerification: this.newPassVerification
    })
      .then(() => {
        this.isSuccess = true;
      })
      .catch(e => {
        this.currentPasswordValidationMsg = e;
      });

    this.hideError();
  }

  openDialog() {
    this.isConfirmDialogOpen = true;
  }

  closeConfirm() {
    this.isConfirmDialogOpen = false;
  }

  movePage() {
    this.$router.push(getRoutePath("DashboardPage"));
  }

  setValue(key: string, value: string) {
    this[key] = value;
  }
}
